import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ClipboardList, Search, PenLine, Scale, Layers } from 'lucide-react';
const modules = [{
  num: 1,
  emoji: '📘',
  icon: BookOpen,
  title: 'Manual Maestro de Gestión Administrativa HyS',
  desc: 'La guía principal para organizar tu gestión profesional, con documentación, protocolos y un plan de implementación en 7 días.'
}, {
  num: 2,
  emoji: '📋',
  icon: ClipboardList,
  title: 'Pack Completo de Formularios de Campo',
  desc: 'Formularios profesionales para registrar visitas, capacitaciones, entregas de EPP e investigaciones. Listos para usar.'
}, {
  num: 3,
  emoji: '🔍',
  icon: Search,
  title: 'Módulo de Auditoría Rápida en Sitio',
  desc: 'Checklists listos para inspecciones, relevamientos y auditorías, sin olvidarte de ningún detalle.'
}, {
  num: 4,
  emoji: '✍️',
  icon: PenLine,
  title: 'Modelos de Redacción Técnica',
  desc: 'Documentos técnicos pre-redactados para completar y utilizar en minutos, sin empezar desde cero.'
}, {
  num: 5,
  emoji: '⚖️',
  icon: Scale,
  title: 'Blindaje Legal del Profesional HyS',
  desc: 'La guía práctica para trabajar con respaldo legal, evitar errores y proteger tu responsabilidad profesional.'
}];
export function ModulesSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-116">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-117">
        <div className="text-center mb-10" data-id="element-118">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#566049] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-119">
            <Layers className="w-4 h-4 text-[#d4a017]" data-id="element-120" />5 Bloques Incluidos
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight" data-id="element-121">
            Todo el sistema en{' '}
            <span className="italic text-[#6f7a64]" data-id="element-122">
              5 bloques listos para usar
            </span>
          </h2>
        </div>

        <div className="space-y-5" data-id="element-123">
          {modules.map((m, i) => {
          const Icon = m.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-5 bg-white border border-slate-200 rounded-2xl p-6 md:p-7 shadow-sm" data-id="element-124">
                <div className="flex-shrink-0 flex flex-col items-center gap-2" data-id="element-125">
                  <div className="w-14 h-14 rounded-2xl bg-[#f4efe2] border border-amber-100 flex items-center justify-center" data-id="element-126">
                    <Icon className="w-7 h-7 text-[#6f7a64]" aria-hidden="true" data-id="element-127" />
                  </div>
                  <span className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#6f7a64]" data-id="element-128">
                    Bloque {m.num}
                  </span>
                </div>
                <div data-id="element-129">
                  <h3 className="font-heading font-bold text-[#2f3a2c] text-xl md:text-2xl mb-2" data-id="element-130">
                    <span aria-hidden="true" className="mr-1" data-id="element-131">
                      {m.emoji}
                    </span>
                    {m.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-[15px] md:text-base" data-id="element-132">
                    {m.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}